// Central registry of services and tools, used by <RelatedServices>.
// Single source of truth for cross-link names and routes.

export type ServiceType = "leistung" | "tool";

export type ServiceEntry = {
  id: string;
  type: ServiceType;
  de: { name: string; path: string };
  en: { name: string; path: string };
};

export const services: Record<string, ServiceEntry> = {
  "performance-marketing": {
    id: "performance-marketing",
    type: "leistung",
    de: { name: "Performance Marketing", path: "/leistungen/performance-marketing" },
    en: { name: "Performance Marketing", path: "/en/services/performance-marketing" },
  },
  "seo-ai-seo": {
    id: "seo-ai-seo",
    type: "leistung",
    de: { name: "SEO & AI SEO", path: "/leistungen/seo-ai-seo" },
    en: { name: "SEO & AI SEO", path: "/en/services/seo-ai-seo" },
  },
  "geo-generative-engine-optimization": {
    id: "geo-generative-engine-optimization",
    type: "leistung",
    de: { name: "GEO — Generative Engine Optimization", path: "/leistungen/geo-generative-engine-optimization" },
    en: { name: "GEO — Generative Engine Optimization", path: "/en/services/geo-generative-engine-optimization" },
  },
  "conversion-web-optimierung": {
    id: "conversion-web-optimierung",
    type: "leistung",
    de: { name: "Conversion- & Web-Optimierung", path: "/leistungen/conversion-web-optimierung" },
    en: { name: "Conversion & Web Optimization", path: "/en/services/conversion-optimization" },
  },
  "conversion-rate-optimierung": {
    id: "conversion-rate-optimierung",
    type: "leistung",
    de: { name: "Conversion-Rate-Optimierung", path: "/leistungen/conversion-rate-optimierung" },
    en: { name: "Conversion Rate Optimization", path: "/en/services/conversion-rate-optimization" },
  },
  "tracking-datenbasis": {
    id: "tracking-datenbasis",
    type: "leistung",
    de: { name: "Tracking & Datenbasis", path: "/leistungen/tracking-datenbasis" },
    en: { name: "Tracking & Data Foundation", path: "/en/services/tracking-data-foundation" },
  },
  "strategie-koordination": {
    id: "strategie-koordination",
    type: "leistung",
    de: { name: "Strategie & Koordination", path: "/leistungen/strategie-koordination" },
    en: { name: "Strategy & Coordination", path: "/en/services/strategic-coordination" },
  },
  "entwicklung-digitaler-dienste": {
    id: "entwicklung-digitaler-dienste",
    type: "leistung",
    de: { name: "Entwicklung digitaler Dienste", path: "/leistungen/entwicklung-digitaler-dienste" },
    en: { name: "Digital Services Development", path: "/en/services/digital-development" },
  },
  "website-entwicklung": {
    id: "website-entwicklung",
    type: "leistung",
    de: { name: "Website-Entwicklung", path: "/leistungen/website-entwicklung" },
    en: { name: "Website Development", path: "/en/services/website-development" },
  },
  "shop-entwicklung": {
    id: "shop-entwicklung",
    type: "leistung",
    de: { name: "Onlineshop-Entwicklung", path: "/leistungen/onlineshop-entwicklung" },
    en: { name: "E-Commerce Development", path: "/en/services/ecommerce-development" },
  },
  "shopify-agentur": {
    id: "shopify-agentur",
    type: "leistung",
    de: { name: "Shopify-Agentur", path: "/leistungen/onlineshop-entwicklung/shopify-agentur" },
    en: { name: "Shopify Agency", path: "/en/services/ecommerce-development/shopify-agency" },
  },
  "tools": {
    id: "tools",
    type: "leistung",
    de: { name: "Tools", path: "/leistungen/tools" },
    en: { name: "Tools", path: "/en/services/tools" },
  },
  "delta": {
    id: "delta",
    type: "tool",
    de: { name: "Delta", path: "/leistungen/delta" },
    en: { name: "Delta", path: "/en/services/delta" },
  },
  "picazzoo": {
    id: "picazzoo",
    type: "tool",
    de: { name: "picazzoo", path: "/leistungen/picazzoo" },
    en: { name: "picazzoo", path: "/en/services/picazzoo" },
  },
  "gonzalads": {
    id: "gonzalads",
    type: "tool",
    de: { name: "GonzalAds", path: "/leistungen/gonzalads" },
    en: { name: "GonzalAds", path: "/en/services/gonzalads" },
  },
  "pm-google-ads": {
    id: "pm-google-ads",
    type: "leistung",
    de: { name: "Google Ads", path: "/leistungen/performance-marketing/google-ads" },
    en: { name: "Google Ads", path: "/en/services/performance-marketing/google-ads" },
  },
  "pm-meta-ads": {
    id: "pm-meta-ads",
    type: "leistung",
    de: { name: "Meta Ads", path: "/leistungen/performance-marketing/meta-ads" },
    en: { name: "Meta Ads", path: "/en/services/performance-marketing/meta-ads" },
  },
  "pm-linkedin-ads": {
    id: "pm-linkedin-ads",
    type: "leistung",
    de: { name: "LinkedIn Ads", path: "/leistungen/performance-marketing/linkedin-ads" },
    en: { name: "LinkedIn Ads", path: "/en/services/performance-marketing/linkedin-ads" },
  },
  "pm-tiktok-ads": {
    id: "pm-tiktok-ads",
    type: "leistung",
    de: { name: "TikTok Ads", path: "/leistungen/performance-marketing/tiktok-ads" },
    en: { name: "TikTok Ads", path: "/en/services/performance-marketing/tiktok-ads" },
  },
  "pm-microsoft-ads": {
    id: "pm-microsoft-ads",
    type: "leistung",
    de: { name: "Microsoft Ads", path: "/leistungen/performance-marketing/microsoft-ads" },
    en: { name: "Microsoft Ads", path: "/en/services/performance-marketing/microsoft-ads" },
  },
  "pm-youtube-demand-gen": {
    id: "pm-youtube-demand-gen",
    type: "leistung",
    de: { name: "YouTube & Demand Gen", path: "/leistungen/performance-marketing/youtube-demand-gen" },
    en: { name: "YouTube & Demand Gen", path: "/en/services/performance-marketing/youtube-demand-gen" },
  },
  "pm-affiliate-marketing": {
    id: "pm-affiliate-marketing",
    type: "leistung",
    de: { name: "Affiliate-Marketing", path: "/leistungen/performance-marketing/affiliate-marketing" },
    en: { name: "Affiliate Marketing", path: "/en/services/performance-marketing/affiliate-marketing" },
  },
};
